import { PaymentDetailsType } from 'scb-shared';

export const formatIban = (cardNumber: string) => {
  const numbersArr = cardNumber.split('');
  const res = [
    numbersArr.slice(0, 2).join(''),
    numbersArr.slice(2, 4).join(''),
    numbersArr.slice(4, 9).join(''),
    numbersArr.slice(9, 14).join(''),
    numbersArr.slice(14).join(''),
  ];
  return res.join(' ');
};

export const formatCreditCardNumber = (cardNumber: string) =>
  cardNumber.replace(/ /g, '')
    .split('')
    .reduce(
      (withSpaces, char, index) =>
        (index + 1) % 4 === 0 && index + 1 !== cardNumber.length
          ? [...withSpaces, char, ' ']
          : [...withSpaces, char],
      [] as string[],
    )
    .join('');

export const propertyFormat = (
  type: string,
  value: string,
  options: { isMonoLink: boolean } = { isMonoLink: true },
) => {
  switch (type) {
    case PaymentDetailsType.CARD: {
      return formatCreditCardNumber(value);
    }
    case PaymentDetailsType.IBAN: {
      return formatIban(value);
    }
    case PaymentDetailsType.MONOBANK_ACCUMULATION: {
      return options.isMonoLink ? (
        <a href={value} target={'_blank'}>
          {value}
        </a>
      ) : (
        value
      );
    }
    default:
      return value;
  }
};

export {};
